export enum CustomColumnFieldTypeEnum {
  String = 1,
  Int = 2,
  RichText = 3
}
